import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import axiosInstance from '../../utils/axios';
import { showToast } from '../reusables/CommonFunction';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

const CommunicationNotifications = () => {
    let { userDetails } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [communicationStatus, setCommunicationStatus] = useState({ smsStatus: false });

    const handleToggleChange = (oEvent) => {
        const { name, checked } = oEvent.target;
        setCommunicationStatus((prevState) => ({
            ...prevState,
            [name]: checked
        }));
    };

    const onPressUpdateSettings = async (oEvent) => {
        oEvent.preventDefault();
        setIsSubmitting(true);
        setLoading(true);
        try {
            const response = await axiosInstance.put(`/clinics/${userDetails.clinic_id}/`, {
                communication_sms_status: communicationStatus.smsStatus === true ? "A" : "D"
            });

            if (response.status === 200) {
                showToast("success", "Communication settings updated successfully.");
            } else if (response.status === 403 && response.data.detail === "Your clinic plan has expired.") {
                showToast("error", "You cannot update Communication settings as your clinic plan has expired. Please renew your plan to manage settings.");
            } else {
                showToast("error", "Failed to update Communication settings.");
            }

        } catch (error) {
            if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                showToast("error", "You cannot update Communication settings as your clinic plan has expired. Please renew your plan to manage settings.");
            } else {
                showToast("error", "Failed to update Communication settings. Please try again later.");
            }
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        const fetchCommunicationStatus = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get(`/clinics/get_communication_status/`, {
                    params: {
                        clinicId: userDetails.clinic_id
                    }
                });
                if (response.status === 200) {
                    setCommunicationStatus({
                        smsStatus: response.data.data.communication_sms_status
                    });
                } else {
                    showToast("error", "Failed to fetch Communication settings.");
                }
            } catch (error) {
                console.error("Error fetching Communication settings:", error);
                showToast("error", "Failed to fetch Communication settings.");
            } finally {
                setLoading(false);
            }
        }
        fetchCommunicationStatus();
    }, [userDetails]);

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Communication Notifications</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formCommunicationStatus">
                                    <Form.Label>SMS Notifications</Form.Label>
                                    <Form.Check
                                        type="switch"
                                        name='smsStatus'
                                        label={communicationStatus.smsStatus ? "Active" : "Deactive"}
                                        checked={communicationStatus.smsStatus}
                                        onChange={handleToggleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formNotificationInfo">
                                    <Form.Text className="text-muted small d-block mb-2">
                                        <strong>Important:</strong> Disabling SMS notifications means:
                                    </Form.Text>

                                    <Form.Text as="div" className="text-muted small">
                                        <ul className="ms-3 mb-2">
                                            <li>Patients won't receive SMS for new or rescheduled appointments</li>
                                            <li>No appointment reminders will be sent to patients</li>
                                            <li>Doctors will not be notified of upcoming appointments via SMS</li>
                                        </ul>
                                    </Form.Text>

                                    <Form.Text className="text-muted small d-block">
                                        Keep notifications enabled to ensure smooth communication and a better experience for both patients and doctors.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formUpdateButton">
                                    <Button type="submit" variant="primary" disabled={userDetails.user_type === "M" || isSubmitting} onClick={onPressUpdateSettings} className="form-control">
                                        {isSubmitting ? "Saving..." : "Update Settings"}
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
            </Container>
            <ToastContainer />
            <BusyLoaderOverlay show={loading} />
        </>
    );
};

export default CommunicationNotifications;
